"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewRect = void 0;
var getRectForDirection_1 = require("./getRectForDirection");
var createNewRect = function (_a, boundaryInset) {
    var direction = _a.direction, align = _a.align, childRect = _a.childRect, popupRect = _a.popupRect, boundaryRect = _a.boundaryRect, offset = _a.offset, reposition = _a.reposition;
    var rect = (0, getRectForDirection_1.getRectForDirection)(direction, align, childRect, popupRect, offset);
    var boundaryCollision = reposition &&
        ((direction === 'top' && rect.top < boundaryRect.top + boundaryInset) ||
            (direction === 'left' && rect.left < boundaryRect.left + boundaryInset) ||
            (direction === 'right' && rect.right > boundaryRect.right - boundaryInset) ||
            (direction === 'bottom' && rect.bottom > boundaryRect.bottom - boundaryInset));
    return {
        rect: rect,
        boundaryCollision: boundaryCollision,
    };
};
exports.createNewRect = createNewRect;
